import { defineNuxtPlugin } from '#app'
import { addCollection } from '@iconify/vue'

// Import the icons directly from the JSON data
export default defineNuxtPlugin(() => {
  addCollection({
    prefix: 'heroicons',
    icons: {
      bicycle: {
        body: `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>`,
        width: 24,
        height: 24
      }
    }
  })
}) 